<template>
    <div class="see-you-there" >
        <svg 
            id="Layer_1" 
            :class="{ 'closed': blink }"
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 494.75 493.77">
            <g id="ribbon">
                <polygon
                    class="cls-3"
                    points="222.13 445.75 188.93 473.53 173.22 433.2 134.16 451.84 128.98 408.87 86.5 417.22 92.17 374.31 48.95 371.83 65.11 331.68 23.87 318.53 49.51 283.65 12.83 260.67 46.34 233.26 16.53 201.87 55.8 183.66 34.74 145.85 77.3 137.98 66.3 96.11 109.48 99.07 109.24 55.79 150.33 69.39 160.86 27.41 197.28 50.8 217.92 12.76 247.37 44.48 276.83 12.76 297.47 50.8 333.89 27.41 344.42 69.39 385.51 55.79 385.26 99.07 428.45 96.11 417.45 137.98 460.01 145.85 438.95 183.66 478.22 201.87 448.41 233.26 481.92 260.67 445.24 283.65 470.88 318.53 429.64 331.68 445.8 371.83 402.58 374.31 408.25 417.22 365.77 408.87 360.59 451.84 321.53 433.2 305.82 473.53 272.62 445.75 247.37 480.91 222.13 445.75"
                />
                <path
                    class="cls-2"
                    d="M219.53,25.52l16.85,18.15,10.99,11.84,10.99-11.84,16.85-18.15,11.81,21.77,7.7,14.2,13.59-8.73,20.83-13.39,6.02,24.02,3.93,15.67,15.33-5.08,23.51-7.78-.14,24.76-.09,16.15,16.12-1.1,24.71-1.69-6.29,23.95-4.1,15.62,15.88,2.94,24.35,4.5-12.05,21.63-7.86,14.11,14.65,6.8,22.47,10.42-17.05,17.96-11.12,11.71,12.5,10.23,19.17,15.68-20.98,13.15-13.69,8.58,9.57,13.02,14.67,19.95-23.59,7.52-15.39,4.91,6.03,14.99,9.24,22.97-24.72,1.42-16.13.92,2.11,16.01,3.24,24.55-24.3-4.78-15.85-3.12-1.93,16.04-2.97,24.58-22.35-10.67-14.58-6.96-5.86,15.05-8.99,23.07-18.99-15.89-12.39-10.37-9.42,13.12-14.44,20.11-14.44-20.11-9.42-13.12-12.39,10.37-18.99,15.89-8.99-23.07-5.86-15.05-14.58,6.96-22.35,10.67-2.97-24.58-1.93-16.04-15.85,3.12-24.3,4.78,3.24-24.55,2.11-16.01-16.13-.92-24.72-1.42,9.24-22.97,6.03-14.99-15.39-4.91-23.59-7.52,14.67-19.95,9.57-13.02-13.69-8.58-20.98-13.15,19.17-15.68,12.5-10.23-11.12-11.71-17.05-17.96,22.47-10.42,14.65-6.8-7.86-14.11-12.05-21.63,24.35-4.5,15.88-2.94-4.1-15.62-6.29-23.95,24.71,1.69,16.12,1.1-.09-16.15-.14-24.76,23.51,7.78,15.33,5.08,3.93-15.67,6.02-24.02,20.83,13.39,13.59,8.73,7.7-14.2,11.81-21.77M278.44,0l-31.07,33.45L216.31,0l-21.77,40.13-38.41-24.68-11.11,44.28-43.34-14.35.26,45.65-45.55-3.12,11.6,44.16-44.89,8.3,22.22,39.88L3.9,199.46l31.44,33.1L0,261.47l38.68,24.25-27.04,36.78,43.5,13.86-17.04,42.35,45.58,2.61-5.98,45.26,44.8-8.81,5.47,45.33,41.2-19.67,16.57,42.54,35.01-29.3,26.63,37.08,26.63-37.08,35.01,29.3,16.57-42.54,41.2,19.67,5.47-45.33,44.8,8.81-5.98-45.26,45.58-2.61-17.04-42.35,43.5-13.86-27.04-36.78,38.68-24.25-35.34-28.9,31.44-33.1-41.42-19.21,22.22-39.88-44.89-8.3,11.6-44.16-45.55,3.12.26-45.65-43.34,14.35-11.11-44.28-38.41,24.68L278.44,0h0Z"
                />
            </g>
            <g id="eye">
                <path
                    class="cls-2"
                    d="M239.98,183.92c31.43,0,56.68,11.6,79.6,28.83,9.41,7.07,17.79,15.53,26.56,23.44,2.33,2.1,3.9,4.39.93,7.5-21.68,22.69-46.43,40.6-77.02,49.36-28.6,8.19-55.67,3.26-81.63-10-18.96-9.69-35.4-22.74-50.18-37.98-3.25-3.35-3.46-5.77-.08-9.22,23.43-23.97,49.93-42.74,83.41-49.94,1.81-.39,3.61-.9,5.43-1.06,4.97-.43,9.96-.71,12.98-.92ZM241.37,279.44c21.67.29,39.52-16.9,39.88-38.42.36-21.36-17.15-39.48-38.55-39.89-21.07-.4-39.63,17.27-39.89,37.97-.27,22.12,16.86,40.05,38.55,40.34ZM289.67,268.79c2.59-1.21,4.38-1.73,5.79-2.76,10-7.26,19.9-14.65,29.87-21.94,3.43-2.51,3.51-4.87.07-7.38-10.44-7.59-20.85-15.22-31.35-22.74-1-.71-2.48-.75-4.17-1.22,8.09,29.29,9.29,21.45-.22,56.04ZM194.82,213.13c-1.36-.13-2.05-.42-2.37-.19-11.71,8.31-23.44,16.6-34.95,25.17-.74.55-.51,4.22.41,4.91,11.39,8.43,23,16.59,34.58,24.77.31.22.99-.09,2.31-.26-9.09-18.16-9.21-36.25.02-54.4Z"
                />
                <path
                    class="cls-2"
                    d="M246.59,238.95c4.54,0,8.98,0,13.41,0,8.65.01,9.67,1.48,6.85,9.82-4.83,14.28-20.18,21.28-34.66,15.79-13.25-5.02-19.95-21.22-14.26-34.5,5.87-13.7,21.89-19.75,35.25-13.31,5.89,2.84,6.24,4.34,2.14,9.26-2.83,3.4-5.66,6.81-8.46,10.24-.19.23-.09.7-.27,2.69Z"
                />
            </g>
            <g id="text">
                <path
                    class="cls-1"
                    d="M90.05,164.71l-2.93-2.19,3.91-5.24,13.02,9.72-3.92,5.24-2.96-2.21c-5-.27-8.94,1.52-11.82,5.37-1.76,2.36-2.63,4.52-2.62,6.48.01,1.96.91,3.61,2.7,4.95,1.71,1.28,3.45,1.66,5.23,1.13,1.78-.52,3.9-1.77,6.35-3.75l5.11-4.04c3.25-2.57,6.22-4.19,8.91-4.86,2.69-.67,5.02-.68,6.98-.02,1.97.66,3.92,1.71,5.86,3.15,3.89,2.91,6.07,6.43,6.54,10.56s-.83,8.24-3.88,12.33c-2.91,3.89-6.98,6.37-12.21,7.44l3.56,2.66-4,5.36-15.64-11.68,4-5.36,3.79,2.83c6.63.95,11.48-.63,14.56-4.75,1.8-2.41,2.58-4.75,2.33-7.01-.25-2.26-1.51-4.23-3.77-5.92-3.08-2.3-6.83-1.73-11.26,1.71l-5.51,4.23c-3.98,3.03-7.6,4.77-10.86,5.21-3.26.44-6.42-.49-9.5-2.79-3.78-2.82-5.88-6.13-6.29-9.91-.41-3.79.85-7.64,3.78-11.58,2.55-3.42,6.07-5.77,10.54-7.04Z"
                />
                <path
                    class="cls-1"
                    d="M147.27,135.85l-4.7-6.36-16.28,12.02,8.37,11.33,14.16-10.46,3.5,4.75-14.16,10.46,9.21,12.47,16.28-12.02-5.12-6.94,4.7-3.47,8.63,11.69-31.63,23.35-3.5-4.75,4.9-3.61-21.08-28.55-4.9,3.62-3.5-4.75,31.63-23.35,8.2,11.11-4.7,3.47Z"
                />
                <path
                    class="cls-1"
                    d="M196.84,113.72l-2.67-7.44-19.05,6.84,4.76,13.26,16.57-5.95,1.99,5.55-16.57,5.95,5.24,14.59,19.05-6.84-2.91-8.12,5.49-1.97,4.91,13.67-37.01,13.28-1.99-5.55,5.73-2.06-11.99-33.4-5.73,2.06-1.99-5.55,37.01-13.28,4.66,13-5.49,1.97Z"
                />
                <path
                    class="cls-1"
                    d="M265.13,94.39l9.23,18.05,13.12-14.8-6.62-.96.96-6.62,21.18,3.08-.96,6.62-6.93-1.01-18.09,20.11-2.55,17.53,7.29,1.06-.96,6.62-22.42-3.26.96-6.62,7.14,1.04,2.55-17.52-12.56-24.58-6.48-.94.96-6.62,21.78,3.17-.96,6.62-6.65-.97Z"
                />
                <path
                    class="cls-1"
                    d="M356.08,152.45c-2.39,4.17-5.44,7.36-9.14,9.55-3.71,2.19-7.69,3.24-11.95,3.15-4.26-.09-8.46-1.32-12.6-3.7-4.08-2.34-7.19-5.34-9.31-9-2.12-3.66-3.13-7.63-3.04-11.9.1-4.27,1.32-8.45,3.66-12.53,2.32-4.05,5.29-7.14,8.92-9.28,3.63-2.14,7.54-3.2,11.74-3.16,4.2.03,8.32,1.21,12.37,3.53,4.21,2.41,7.41,5.47,9.61,9.18,2.19,3.71,3.27,7.67,3.23,11.88-.04,4.22-1.2,8.32-3.48,12.29ZM325.77,156.13c2.81,1.61,5.75,2.32,8.81,2.12,3.06-.2,5.88-1.17,8.49-2.91,2.6-1.74,4.69-3.99,6.27-6.75,1.61-2.81,2.47-5.79,2.57-8.93.1-3.14-.58-6.05-2.03-8.72-1.46-2.68-3.6-4.83-6.43-6.45-2.78-1.59-5.62-2.32-8.54-2.2-2.92.12-5.64,1.04-8.17,2.75-2.53,1.71-4.63,4.01-6.3,6.92-1.77,3.08-2.76,6.17-2.97,9.25-.21,3.08.39,5.93,1.82,8.53,1.43,2.6,3.59,4.73,6.5,6.4Z"
                />
                <path
                    class="cls-1"
                    d="M388.86,160.52l-18.37,15.59c-3.24,2.75-5.08,5.38-5.53,7.88-.45,2.51.34,4.96,2.37,7.35,2.06,2.42,4.37,3.64,6.93,3.65,2.56,0,5.46-1.36,8.7-4.11l18.42-15.63-3.57-4.21,4.5-3.82,11.98,14.12-4.5,3.82-3.82-4.5-18.92,16.06c-4.31,3.66-8.51,5.35-12.62,5.09-4.1-.26-7.94-2.5-11.52-6.71-3.6-4.24-5.18-8.38-4.75-12.41.43-4.03,2.92-7.98,7.47-11.83l18.61-15.8-3.78-4.45,4.5-3.82,12.02,14.16-4.5,3.82-3.61-4.26Z"
                />
                <path class="cls-1" d="M141.9,324.88l11.15-9.69-8.84-10.18-34.75,30.19,5.57,6.41-5.78,5.02-17.51-20.16,5.78-5.02,5.46,6.28,34.75-30.19-8.78-10.11-11.15,9.69-5.29-6.09,16.93-14.71,34.68,39.92-16.93,14.71-5.29-6.09Z" />
                <path
                    class="cls-1"
                    d="M176.88,338.39l-6.03,14.06,23.02,9.88,6.03-14.06-6.19-2.66,2.66-6.2,20.28,8.71-2.66,6.2-6.12-2.62-16.02,37.32,6.12,2.62-2.66,6.2-20.28-8.71,2.66-6.2,6.19,2.66,7.32-17.06-23.02-9.88-7.32,17.06,6.26,2.69-2.66,6.2-20.25-8.69,2.66-6.2,5.98,2.56,16.02-37.32-5.97-2.56,2.66-6.2,20.24,8.69-2.66,6.2-6.26-2.69Z"
                />
                <path
                    class="cls-1"
                    d="M263.79,364.73v-9.05s-24.66-.03-24.66-.03l-.02,16.12,21.46.03v6.75s-21.47-.03-21.47-.03l-.02,17.74,24.67.03v-9.88s7.13,0,7.13,0l-.02,16.63-47.92-.06v-6.75s7.43,0,7.43,0l.05-40.62h-7.42s0-6.76,0-6.76l47.92.06-.02,15.8h-7.11Z"
                />
                <path
                    class="cls-1"
                    d="M324.46,343.69c1.35,3.2,1.52,6.29.51,9.28-1.01,2.99-3.07,5.62-6.17,7.89l16.99,14.07,6.48-2.74,2.63,6.22-11.91,5.03-21.54-18.27-7.43,3.14,7.18,17,6.76-2.86,2.63,6.22-21.99,9.29-2.63-6.22,7.19-3.04-15.81-37.41-7.19,3.04-2.63-6.22,22.05-9.32c6.84-2.89,12.21-3.92,16.13-3.11,3.91.82,6.83,3.48,8.74,8ZM316.12,347.06c-.98-2.32-2.47-3.69-4.48-4.11-2.01-.43-4.69.07-8.05,1.49l-8.21,3.47,5.98,14.16,7.72-3.26c3.45-1.46,5.77-3.1,6.97-4.93,1.19-1.83,1.22-4.1.07-6.81Z"
                />
                <path
                    class="cls-1"
                    d="M366.8,306.25l-6.72-6.06-16.52,18.32,11.98,10.8,14.37-15.94,5.02,4.52-14.37,15.94,13.18,11.88,16.52-18.32-7.33-6.61,4.76-5.28,12.35,11.13-32.09,35.6-5.02-4.52,4.97-5.51-30.17-27.19-4.97,5.51-5.01-4.52,32.09-35.6,11.74,10.58-4.76,5.28Z"
                />
            </g>
            <path id="closed-eye" class="cls-2" d="M343.47,235.59l-202.74-3.8c-4.1-.09-7.56,3.22-7.64,7.36s3.22,7.56,7.36,7.64l202.74,3.8s.1,0,.14,0c4.08,0,7.42-3.27,7.5-7.36.08-4.14-3.22-7.56-7.36-7.64Z" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'SeeYouThere',
    data() {
        return {
            blink: false,
            intervalId: null,
            timeoutId: null,
        }
    },
    mounted() {
        this.startBlinkCycle();    
    },
    beforeUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
        if (this.timeoutId) {
            clearTimeout(this.timeoutId)
        }
    },
    methods: {
        startBlinkCycle() {
            this.intervalId = setInterval(() => {
                this.blink = true
                
                this.timeoutId = setTimeout(() => {
                    this.blink = false
                }, 1000)
            }, 7000)
        }
    },
}
</script>

<style scoped>
.cls-1{stroke:#ED0000;stroke-miterlimit:10;}
.cls-2,.cls-3{stroke-width:5px;stroke:#ED0000}
.cls-3{fill:#f1f380;}

#closed-eye {
    opacity: 0;
}

.closed #closed-eye {
    opacity: 1;
}

.closed #eye {
    opacity: 0;
}

.see-you-there:hover #eye {
    opacity: 0;
}

.see-you-there:hover #closed-eye {
    opacity: 1;
}
</style>
